import React, { useState } from "react";
import moment from "moment";
import { Barras, CORES, numero, pontos } from "../../Components/Graficos";
import { Painel, Filtro, TabelaDashboard, Abas, useDashboard, useFiltro, MESES } from "./Painel";

const SERIE = [{ nome: "", cor: CORES[3] }];
const DIREITA = { muiTableHeadCellProps: { align: "right" }, muiTableBodyCellProps: { align: "right" } };
const COLUNA_PARTICIPANTE = [
  { accessorKey: "nome", header: "Nome" },
  { accessorKey: "login", header: "CPF" },
  { accessorKey: "concessionaria", header: "Concessionária", Cell: ({ cell }) => cell.getValue() || "-" },
];

const filtrosPeriodo = (filtro, set, anos) => (
  <>
    <Filtro label="Ano" value={filtro.ano} onChange={set("ano")} opcoes={anos.map((a) => ({ value: a, label: a }))} />
    <Filtro label="Mês" value={filtro.mes} onChange={set("mes")} opcoes={MESES} />
  </>
);

function PontuacaoAba({ anos, atualizacao }) {
  const [filtro, set] = useFiltro({ ano: "", mes: "" });
  const { dados } = useDashboard("pontuacao", filtro);
  const { dados: saldos } = useDashboard("pontuacao/saldos");
  const { dados: aExpirar } = useDashboard("pontuacao/a-expirar", filtro);
  const d = dados || {};

  return (
    <>
      <Painel titulo="Pontuação" atualizacao={atualizacao} filtros={filtrosPeriodo(filtro, set, anos)}>
        <Barras
          titulo="Pontuação"
          series={SERIE}
          formato={pontos}
          etiqueta
          dados={[
            ["Pontos creditados", d.pontosCreditados],
            ["Saldo atual", d.saldo],
            ["Pontos a expirar", d.pontosAExpirar],
            ["Pontos expirados", d.pontosExpirados],
            ["Pontos resgatados", d.pontosResgatados],
          ].map(([label, v]) => ({ label, valores: [v || 0] }))}
        />
      </Painel>

      <Painel
        titulo="Participantes com saldo"
        atualizacao={atualizacao}
        exportar={{ path: "pontuacao/saldos/exportar", nome: "Participantes com saldo" }}
      >
        <TabelaDashboard
          dados={saldos}
          colunas={[...COLUNA_PARTICIPANTE, { accessorKey: "saldo", header: "Saldo", Cell: ({ cell }) => pontos(cell.getValue()), ...DIREITA }]}
        />
      </Painel>

      <Painel
        titulo="Participantes com pontos a expirar"
        atualizacao={atualizacao}
        exportar={{ path: "pontuacao/a-expirar/exportar", params: filtro, nome: "Participantes com pontos a expirar" }}
      >
        <TabelaDashboard
          dados={aExpirar}
          colunas={[
            ...COLUNA_PARTICIPANTE,
            { accessorKey: "dataExpiracao", header: "Data de expiração", Cell: ({ cell }) => moment(cell.getValue()).format("DD/MM/YYYY") },
            { accessorKey: "pontos", header: "Pontos", Cell: ({ cell }) => pontos(cell.getValue()), ...DIREITA },
          ]}
        />
      </Painel>
    </>
  );
}

function ResgateCatalogo({ anos, atualizacao }) {
  const [filtro, set] = useFiltro({ ano: "", mes: "" });
  const { dados: produtos } = useDashboard("pontuacao/produtos", filtro);
  const { dados: parceiros } = useDashboard("pontuacao/parceiros", filtro);

  return (
    <Painel titulo="Resgate Catálogo Premmiar" atualizacao={atualizacao} filtros={filtrosPeriodo(filtro, set, anos)}>
      <div className="row g-3">
        <div className="col-md-7">
          <Barras
            horizontal
            titulo="Top produtos resgatados"
            series={SERIE}
            dados={(produtos || []).map((p) => ({ label: p.produto, valores: [p.resgates] }))}
          />
        </div>
        <div className="col-md-5">
          <div className="grafico-card">
            <div className="grafico-titulo">TOP 15 Parceiros resgatados</div>
            {(parceiros || []).length === 0 ? (
              <div className="grafico-vazio">Sem dados</div>
            ) : (
              <table className="table table-sm table-striped mb-0 tabela-parceiros">
                <thead>
                  <tr>
                    <th>Posição</th>
                    <th>Parceiro</th>
                    <th className="text-end">Resgates</th>
                  </tr>
                </thead>
                <tbody>
                  {parceiros.map((p, i) => (
                    <tr key={p.parceiro}>
                      <td>{i + 1}º</td>
                      <td>{p.parceiro}</td>
                      <td className="text-end">{numero(p.resgates)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </Painel>
  );
}

const ABAS = [
  ["Pontuação", PontuacaoAba],
  ["Resgate Catálogo Premmiar", ResgateCatalogo],
];

export default function Pontuacao() {
  const [aba, setAba] = useState(0);
  const { dados: anos } = useDashboard("pontuacao/anos");
  // data da última carga do catálogo (não depende de filtro), usada no cabeçalho das duas abas
  const { dados: geral } = useDashboard("pontuacao");
  const atualizacao = geral?.ultimaAtualizacao ? moment(geral.ultimaAtualizacao).format("DD/MM/YYYY HH:mm:ss") : "";
  const Aba = ABAS[aba][1];

  return (
    <div className="row">
      <span className="tituloPagina">DASHBOARD</span>
      <Abas abas={ABAS.map((a) => a[0])} aba={aba} onChange={setAba} />
      <Aba anos={anos || []} atualizacao={atualizacao} />
    </div>
  );
}
